//Arquivo com as configurações de layout que entendermos como necessárias
//muitas dessas opções serão trazidas do bd eventualmente, mas por hora colocar tudo aqui

module.exports = {
	projectFilterOptions: [
		{ name: 'Todos os projetos', value: 'all' },
		{ name: 'Projetos em criação', value: 'at-creation' },
		{ name: 'Pós Aprovação', value: 'post-approval' },
		{ name: 'Projeto Finalizado', value: 'approved' },
	],
	dropDownFilterOptions: [
		// {
		//   name: "Modificados Recentemente",
		//   value: "modifiedDate",

		// },
		{ name: 'Por nome', value: 'name' },
		{ name: 'Data de criação', value: 'creationDate', isDefault: true },
	],
	projectStage: [
		{ name: 'Em criação', value: 'at-creation' },
		{ name: 'Pós Aprovação', value: 'post-approval' },
		{ name: 'Finalizado', value: 'approved' },
	],
	projectTypes: [
		{ name: 'Flex', value: 'flex' },
		{ name: 'Smart', value: 'smart' },
		{ name: 'Interno', value: 'interno' },
		{ name: 'Outro', value: 'outro' },
	],
	//melhor buscar por api do rri?
	squads: [
		{ name: 'Piano', value: '270777' },
		{ name: 'Guitarra', value: '264680' },
		{ name: 'Violino', value: '256322' },
		{ name: 'Contrabaixo', value: '256323' },
		{ name: 'Bateria', value: '256324' },
		{ name: 'Violão', value: '256325' },
		{ name: 'Produto', value: '257821' },
	],
	squadBadgeColors: {
		flex: 'blue',
		smart: 'teal',
		outro: 'gray',
		interno: 'orange',
		default: 'purple',
	},
	changeHistoryDummy: [
		{ userName: 'Lucas F', key: 1 },
		{ userName: 'Shoitaum', key: 2 },
		{ userName: 'Shoitaum', key: 3 },
		{ userName: 'Shoitaum', key: 14 },
	],
	pageTypes: [
		{ name: 'Home', value: 'home' },
		{ name: 'Header', value: 'header' },
		{ name: 'Footer', value: 'footer' },
		{ name: 'Página de Produtos', value: 'product' },
		{ name: 'Busca/Dep/Cat', value: 'search' },
		{ name: 'Customizada', value: 'custom' },
	],
	availableComponents: [
		{
			title: 'Nativo',
			components: [
				{
					name: 'Banner Slider',
					id: 'SliderLayout',
					img64: '/images/side-menu/slider-layout.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Tipbar Group',
					id: 'TipbarGroup',
					img64: '/images/side-menu/tipbar.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Shelflist',
					id: 'ProductSummaryList',
					img64: '/images/side-menu/product-summary-list.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Seção de Banner',
					id: 'BannerSectionGroup',
					img64: '/images/side-menu/banner-section-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Newsletter Form',
					id: 'Newsletter',
					img64: '/images/side-menu/newsletter.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Product Description Group',
					id: 'ProductDescriptionGroup',
					img64: '/images/side-menu/product-description.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Related Products',
					id: 'RelatedProducts',
					img64: '/images/side-menu/related-products.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'Vitrine',
					id: 'RelatedProducts',
					img64: '/images/side-menu/related-products.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'BreadcrumbGroup',
					id: 'BreadcrumbGroup',
					img64: '/images/side-menu/breadcrumb.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'ProductImagesDetailsGroup',
					id: 'ProductImagesDetailsGroup',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'BrandGroup',
					id: 'BrandGroup',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'TopHeader',
					id: 'TopHeader',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'ProductSpecificationSection',
					id: 'ProductSpecificationSection',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'BuyTogetherGroup',
					id: 'BuyTogetherGroup',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'SearchResultLayoutDesktop',
					id: 'SearchResultLayoutDesktop',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'SearchResultLayoutMobile',
					id: 'SearchResultLayoutMobile',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['search-1'],
				},
				{
					name: 'InstitutionalGroup',
					id: 'InstitutionalGroup',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'RichTextRow',
					id: 'RichTextRow',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'VideoGroup',
					id: 'VideoGroup',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'RichTextVideo',
					id: 'RichTextVideo',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['DEFAULT'],
				},
				{
					name: 'SellerSelector',
					id: 'SellerSelector',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['product-1'],
				},
				{
					name: 'Menu Desktop',
					id: 'StoreMenuDesktop',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['menu-1'],
				},
				{
					name: 'Menu Mobile',
					id: 'StoreMenuMobile',
					img64: '/images/side-menu/product-images-details-group.png',
					draggableType: ['menu-1'],
				},
			],
		},
		{
			title: 'Custom.',
			components: [],
		},
	],
	scrollBarStyle: {
		'&::-webkit-scrollbar': {
			backgroundColor: '#CBD5E0',
			width: '4px',
			borderRadius: '6px',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#ECC94B',
			borderRadius: '6px',
		},
	},
	placeholder64:
		'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAGQAQMAAAC9Ou/2AAAABlBMVEW7u7u7u7vqh6ZhAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABsUlEQVRoge3WQW6DMBSEYRALlhzBR+Fo5mgchSOwZEFx/Z7tNOFNgqsqqqrOv2GRjyjyiCRNwxhjjDHGGGOMMcYY+8f1YS4XH6TdgEUuw++CVS7u/WB8AbZqoPkrMG4G6C3+9g7rBQgGfCTgC1heg7a80x049MYMumswncGu4MigDw0E7SsQ7sFwWOAF7Bm480lXgfi5uwLMFGfgARgFbAWcpzgDM4WA+FKfQXsNZgucgDUBO0UGQwY9BMs9OL9ewJKAnSKC4RLEs3EZ2ClOwE4RQS9grgR2CgHxrjEDe9I1oBMwKQBTZOATsI+Ngv0OTM9AowBMEUH7BQYM4vmHDOwUjwBMEUETwVEJwBQCQnx2EwBTVAEfn90EwBQKpi4BNEUt2BSgKQSMBaApFMx9JUBTZLAqcE+AuwEwhYJlSABNUQWGJT6/AtAUClaXAJqiFswC4BQC+gzgFAq2sQ7AKTKYBMApBHSXQH4RIoBTPAB00gJa+VWKAE6h4AgK4BR1IBwK4BQCmgTwFN8B6CuugD0B/DdpT3+N3gzkjN8N1gvgfgQYY4wxxhhjjDHGGGN/qk+q/1RYGMS8dwAAAABJRU5ErkJggg==',
};
